import Vue from "vue";
import Vuex from "vuex";
import { auth } from "../utils/firebase.utils.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    brandName: "",
    _isAdmin: false,
    _isAuth: false,
    _teamMemberAdded: false,
    _authUser: {},
    _muted: true,
    tourCompleted: false,
    _acceptInvite: false,
    _currentLocation: {
      name: "Vasai",
      latlong: "19.4003,72.7777",
    },
    _flyPlatforms: [],
    _flyPlatformsType: [],
    _flyPlatformsCategoryType: [],
    _currentUID: localStorage.getItem("CURRENT_UID") || "",
    _currentOriginalUID: "",
    // keeping track of the switched workspace in case page is refreshed and the store is reset
    _WID: localStorage.getItem("CURRENT_WORKSPACE_ID") || "default",
    _allWorkspaces: {},
    _currentUser: {},
    _currentWS: {},
    _referredBy: null,
    _campaign: null,
    _carCacheOlx: {},
    _carCacheBrandQuikr: {},
    _carCacheModelQuikr: {},
    _carCacheVariantQuikr: {},
    _carStateList: [],
    _carCityList: [],
    _carNeighbourhoodList: [],
    _currentWorkspaceOwner:
      localStorage.getItem("CURRENT_WORKSPACE_OWNER") || null,
    _selectedMetrics: ["direction_requests", "call_clicks", "website_clicks"],
    _selectedMobileMetrics: [
      "mobile_maps_impressions",
      "mobile_search_impressions",
    ],
    _selectedDesktopMetrics: [
      "desktop_maps_impressions",
      "desktop_search_impressions",
    ],
    _allFetchedLocationStatsData: {},
    _locationStatsLastFetched: null,
    _selectedStatsMonth: 1,
    _selectedStatsLocations: [],
    _previousMonthMetricsInStore: {},
    _currentAggregatedMetrics: {},
    _previousAggregatedMetrics: {},
    _globalStores: [],
    _availableRankTrackerDates: [],
    // Centralized Firestore data cache: { [collection]: { [date]: data } }
    _firestoreDataCache: {},
    _contentTabData: {},
    _performanceTabData: {},
    _refreshesTabData: {},
    _historicalTabData: {},
  },
  getters: {
    muted: (state) => state._muted,
    isAuth: (state) => state._isAuth,
    authUser: (state) => state._authUser,
    currentLocation: (state) => state._currentLocation,
    flyPlatforms: (state) => state._flyPlatforms,
    flyPlatformsType: (state) => state._flyPlatformsType,
    flyPlatformsCategoryType: (state) => state._flyPlatformsCategoryType,
    currentUID: () => {
      let workspaceId = localStorage.getItem("CURRENT_WORKSPACE_ID");
      let uid = (auth.currentUser || {}).uid;
      if (workspaceId) {
        return workspaceId.toString().split("__")[1] || uid;
      }
      return uid;
    },
    currentOriginalUID: (state) => state._currentOriginalUID,
    WID: () => {
      let storeWID = localStorage.getItem("CURRENT_WORKSPACE_ID") || "default";
      return storeWID.includes("__") ? storeWID.split("__")[0] : storeWID;
    },
    allWorkspaces: (state) => state._allWorkspaces,
    currentWorkspace: (state) => {
      let currentWorkspace = localStorage.getItem("CURRENT_WORKSPACE");
      currentWorkspace = JSON.parse(currentWorkspace);
      if (currentWorkspace) return currentWorkspace;
      return state._currentWS;
    },
    currentUser: (state) => {
      let currentWorkspace = localStorage.getItem("CURRENT_USER");
      currentWorkspace = JSON.parse(currentWorkspace);
      if (currentWorkspace) return currentWorkspace;
      return state._currentUser;
    },
    referredBy: (state) => state._referredBy,
    isAdmin: (state) => state._isAdmin,
    campaign: (state) => state._campaign,
    carCacheOlx: (state) => state._carCacheOlx,
    carCacheBrandQuikr: (state) => state._carCacheBrandQuikr,
    carCacheModelQuikr: (state) => state._carCacheModelQuikr,
    carCacheVariantQuikr: (state) => state._carCacheVariantQuikr,
    carStates: (state) => state._carStateList,
    carCities: (state) => state._carCityList,
    carNeighbourhoods: (state) => state._carNeighbourhoodList,
    getCurrentWorkspaceOwner: (state) => state._currentWorkspaceOwner,
    selectedMetrics: (state) => state._selectedMetrics,
    selectedMobileMetrics: (state) => state._selectedMobileMetrics,
    selectedDesktopMetrics: (state) => state._selectedDesktopMetrics,
    allFetchedLocationStatsData: (state) => state._allFetchedLocationStatsData,
    locationStatsLastFetched: (state) => state._locationStatsLastFetched,
    selectedStatsMonth: (state) => state._selectedStatsMonth,
    selectedStatsLocations: (state) => state._selectedStatsLocations,
    previousMonthMetricsInStore: (state) => state._previousMonthMetricsInStore,
    currentAggregatedMetrics: (state) => state._currentAggregatedMetrics,
    previousAggregatedMetrics: (state) => state._previousAggregatedMetrics,
    globalStores: (state) => state._globalStores,
    availableRankTrackerDates: (state) => state._availableRankTrackerDates,
    // Get cached Firestore data for a collection and date
    getFirestoreData: (state) => (collection, date) => {
      return (
        state._firestoreDataCache[collection] &&
        state._firestoreDataCache[collection][date]
      )
        ? state._firestoreDataCache[collection][date]
        : null;
    },
    contentTabData: (state) => state._contentTabData,
    performanceTabData: (state) => state._performanceTabData,
    refreshesTabData: (state) => state._refreshesTabData,
    historicalTabData: (state) => state._historicalTabData,
  },
  mutations: {
    // Cache Firestore data for a collection and date
    SET_FIRESTORE_DATA(state, { collection, date, data }) {
      if (!state._firestoreDataCache[collection]) {
        state._firestoreDataCache[collection] = {};
      }
      state._firestoreDataCache[collection][date] = data;
    },
    setBrandName(state, brandName) {
      state.brandName = brandName;
    },
    SET_TOUR_COMPLETED(state, value) {
      state.tourCompleted = value;
    },
    SET_IS_ADMIN(state, value) {
      state._isAdmin = value;
    },
    SET_MUTED(state, value) {
      state._muted = value;
    },
    SET_AUTH(state, value) {
      state._isAuth = value;
    },
    SET_USER(state, value) {
      state._authUser = value;
    },
    SET_CURRENT_LOCATION(state, value) {
      localStorage.location = JSON.stringify(value);
      value.ts = new Date().getTime();
      state._currentLocation = value;
    },
    SET_FLY_PLATFORMS(state, value) {
      state._flyPlatforms = value;
    },
    CLEAR_FLY_PLATFORMS(state) {
      state._flyPlatforms = [];
    },
    SET_FLY_PLATFORMS_TYPE(state, value) {
      state._flyPlatformsType = value;
    },
    SET_FLY_PLATFORMS_CATEGORY_TYPE(state, value) {
      state._flyPlatformsCategoryType = value;
    },
    SET_CURRENT_WORKSPACE_ID(state, value) {
      state._WID = value;
      console.log("wid", value);
      /* Saving current workspace id to localstore to handle the case when the store is reset on page refresh and switched workspace is needed to be tracked */
      localStorage.setItem("CURRENT_WORKSPACE_ID", value);
    },
    SET_ALL_WORKSPACES(state, value) {
      state._allWorkspaces = value;
    },
    SET_CURRENT_UID(state, value) {
      state._currentUID = value;
    },
    SET_CURRENT__ORIGINAL_UID(state, value) {
      state._currentOriginalUID = value;
      localStorage.setItem("CURRENT_UID", value);
    },
    SET_CURRENT_USER(state, value) {
      state._currentUser = value;
    },
    SET_REFERRED_BY(state, value) {
      state._referredBy = value;
    },
    SET_CAMPAIGN(state, value) {
      state._campaign = value;
    },
    SET_CAR_CACHE_OLX(state, value) {
      state._carCacheOlx = value;
    },
    SET_CAR_BRAND_CACHE_QUIKR(state, value) {
      state._carCacheBrandQuikr = value;
    },
    SET_CAR_MODEL_CACHE_QUIKR(state, value) {
      state._carCacheModelQuikr = value;
    },
    SET_CAR_VARIANT_CACHE_QUIKR(state, value) {
      state._carCacheVariantQuikr = value;
    },
    SET_CAR_LOCATION_STATES(state, value) {
      state._carStateList = value;
    },
    SET_CAR_LOCATION_CITIES(state, value) {
      state._carCityList = value;
    },
    SET_CAR_LOCATION_NEIGHBOURHOODS(state, value) {
      state._carNeighbourhoodList = value;
    },
    SET_CURRENT_WORKSPACE_OWNER(state, workspaceOwner) {
      state._currentWorkspaceOwner = workspaceOwner;
    },
    SET_CURRENT_WORKSPACE(state, workspace) {
      state._currentWS = workspace;
    },
    SET_TEAM_MEMBER_ADDED(state, value) {
      state._teamMemberAdded = value;
    },
    SET_ACCEPT_INVITE(state, value) {
      state._acceptInvite = value;
    },
    SET_SELECTED_METRICS(state, value) {
      state._selectedMetrics = value;
    },
    SET_SELECTED_MOBILE_METRICS(state, value) {
      state._selectedMobileMetrics = value;
    },
    SET_SELECTED_DESKTOP_METRICS(state, value) {
      state._selectedDesktopMetrics = value;
    },
    SET_SELECTED_STATS_MONTH(state, value) {
      console.log("SET_SELECTED_STATS_MONTH :", value);
      state._selectedStatsMonth = value;
    },
    SET_ALL_FETCHED_LOCATION_STATS_DATA(
      state,
      { wid, monthSelection, date, data }
    ) {
      // console.log('wid :', wid, 'date :', date, 'data :', data)
      if (!state._allFetchedLocationStatsData) {
        state._allFetchedLocationStatsData = {};
      }
      if (!state._allFetchedLocationStatsData[wid]) {
        state._allFetchedLocationStatsData[wid] = {};
      }
      if (!state._allFetchedLocationStatsData[wid][monthSelection]) {
        state._allFetchedLocationStatsData[wid][monthSelection] = {};
      }
      state._allFetchedLocationStatsData[wid][monthSelection][date] = data;
      const today = new Date();
      if (!state._locationStatsLastFetched) {
        state._locationStatsLastFetched = {};
      }
      if (!state._locationStatsLastFetched[wid]) {
        state._locationStatsLastFetched[wid] = {};
      }
      if (!state._locationStatsLastFetched[wid][monthSelection]) {
        state._locationStatsLastFetched[wid][monthSelection] = {};
      }
      state._locationStatsLastFetched[wid][monthSelection] =
        today.toLocaleDateString("en-GB"); // DD-MM-YYYY format
      // console.log('after after :', state._allFetchedLocationStatsData)
    },
    SET_SELECTED_STATS_LOCATIONS(state, value) {
      state._selectedStatsLocations = value;
    },
    SET_PREVIOUS_MONTH_METRICS(state, { wid, monthSelection, data }) {
      if (!state._previousMonthMetricsInStore) {
        state._previousMonthMetricsInStore = {};
      }
      if (!state._previousMonthMetricsInStore[wid]) {
        state._previousMonthMetricsInStore[wid] = {};
      }
      state._previousMonthMetricsInStore[wid][monthSelection] = {
        ...data,
        lastFetchedDate: new Date().toLocaleDateString("en-GB"), // Store fetch date
      };
    },
    SET_CURRENT_AGGREGATED_METRICS(state, { data, monthSelection }) {
      if (!state._currentAggregatedMetrics) {
        state._currentAggregatedMetrics = {}; // Change to object to store both data and metadata
      }
      if (!state._currentAggregatedMetrics[monthSelection]) {
        state._currentAggregatedMetrics[monthSelection] = {};
      }
      state._currentAggregatedMetrics[monthSelection] = {
        data: data, // Store the actual metrics data
        lastFetchedDate: new Date().toLocaleDateString("en-GB"), // Store today's date in DD-MM-YYYY format
      };
    },

    SET_PREVIOUS_AGGREGATED_METRICS(state, { data, monthSelection }) {
      if (!state._previousAggregatedMetrics) {
        state._previousAggregatedMetrics = {}; // Change to object to store both data and metadata
      }
      if (!state._previousAggregatedMetrics[monthSelection]) {
        state._previousAggregatedMetrics[monthSelection] = {};
      }
      state._previousAggregatedMetrics[monthSelection] = {
        data: data, // Store the actual metrics data
        lastFetchedDate: new Date().toLocaleDateString("en-GB"), // Store today's date in DD-MM-YYYY format
      };
    },
    SET_CONTENT_TAB_DATA(state, { data, date, uid }) {
      if (!state._contentTabData) {
        state._contentTabData = {};
      }
      if (!state._contentTabData[date]) {
        state._contentTabData[date] = {};
      }
      // Always update/set the data for the uid to ensure fresh data
      state._contentTabData[date][uid] = data;
    },
    SET_PERFORMANCE_TAB_DATA(state, { data, date, uid }) {
      if (!state._performanceTabData) {
        state._performanceTabData = {};
      }
      if (!state._performanceTabData[date]) {
        state._performanceTabData[date] = {};
      }
      if (!state._performanceTabData[date][uid]) {
        state._performanceTabData[date][uid] = {};
        state._performanceTabData[date][uid] = data;
      }
      if (state._performanceTabData[date][uid]) {
        console.log("uid already exists", uid);
        return;
      }
    },
    SET_REFRESHES_TAB_DATA(state, { data, date, uid }) {
      if (!state._refreshesTabData) {
        state._refreshesTabData = {};
      }
      if (!state._refreshesTabData[date]) {
        state._refreshesTabData[date] = {};
      }
      state._refreshesTabData[date][uid] = data;
    },
    SET_HISTORICAL_TAB_DATA(state, { data, date, uid }) {
      if (!state._historicalTabData) {
        state._historicalTabData = {};
      }
      if (!state._historicalTabData[date]) {
        state._historicalTabData[date] = {};
      }
      state._historicalTabData[date][uid] = data;
    },
    SET_GLOBAL_STORES(state, stores) {
      state._globalStores = stores;
    },
    SET_LOCATION_STATS_LAST_FETCHED(state, timestamp) {
      state._locationStatsLastFetched = timestamp;
    },
    SET_AVAILABLE_RANK_TRACKER_DATES(state, dates) {
      state._availableRankTrackerDates = dates;
    },
  },
  actions: {
    // Generic Firestore fetch and cache action
    async fetchFirestoreData({ commit, getters }, { collection, date, fetchFn }) {
      // If already cached, return cached data
      const cached = getters.getFirestoreData(collection, date);
      if (cached) return cached;
      // fetchFn should be a function that returns a Promise for the Firestore data
      const data = await fetchFn();
      commit("SET_FIRESTORE_DATA", { collection, date, data });
      return data;
    },
    setTourCompleted({ commit }, value) {
      commit("SET_TOUR_COMPLETED", value);
    },
    setCurrentLocation(context) {
      let local = localStorage.location;
      let location = null;
      if (local) {
        location = JSON.parse(local);
      }
      if (location) {
        location.ts = new Date().getTime();
        context.commit("SET_CURRENT_LOCATION", location);
      }
    },

    setCurrentWorkspaceOwner({ commit }, workspaceOwner) {
      commit("SET_CURRENT_WORKSPACE_OWNER", workspaceOwner);
    },

    async fetchAuthUser({ commit }) {
      const user = auth.currentUser;
      if (user) {
        commit("SET_USER", user);
        commit("SET_AUTH", true);
      } else {
        commit("SET_USER", {});
        commit("SET_AUTH", false);
      }
    },
    addTeamMember({ commit }, value) {
      commit("SET_TEAM_MEMBER_ADDED", value);
    },
    acceptTeamInvite({ commit }, value) {
      commit("SET_ACCEPT_INVITE", value);
    },
    resetPageCaches({ commit, dispatch }) {
      console.log("Resetting page caches for workspace switch");

      // Reset review insights cache
      commit("SET_ALL_FETCHED_LOCATION_STATS_DATA", {
        wid: null,
        monthSelection: null,
        date: null,
        data: {},
      });

      // Reset aggregated metrics
      commit("SET_CURRENT_AGGREGATED_METRICS", {
        data: {},
        monthSelection: null,
      });

      commit("SET_PREVIOUS_AGGREGATED_METRICS", {
        data: {},
        monthSelection: null,
      });

      // Reset previous month metrics
      commit("SET_PREVIOUS_MONTH_METRICS", {
        wid: null,
        monthSelection: null,
        data: {},
      });

      // Reset location stats
      commit("SET_SELECTED_STATS_LOCATIONS", []);

      // Signal that data needs to be refreshed
      commit("SET_LOCATION_STATS_LAST_FETCHED", null);

      // Note: Modules like reviewDashboard and searchInsights will be reset when implemented
    },
  },
  modules: {},
});
